import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AutomatedAttendanceOptions } from '@models/session';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lv-automated-attendance-options',
  templateUrl: 'automated-attendance-options.component.html',
  styleUrls: ['automated-attendance-options.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TranslateModule]
})
export class AutomatedAttendanceOptionsComponent {
  @Input() options: AutomatedAttendanceOptions;
}
